import script from "./HrAuditJournal.vue?vue&type=script&lang=ts&setup=true"
export * from "./HrAuditJournal.vue?vue&type=script&lang=ts&setup=true"

import "./HrAuditJournal.vue?vue&type=style&index=0&id=6965076e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6965076e"]])

export default __exports__